import { render, staticRenderFns } from "./LicitacaoEsclarecimentoTabela.vue?vue&type=template&id=9b0466fa&scoped=true"
import script from "./LicitacaoEsclarecimentoTabela.vue?vue&type=script&lang=js"
export * from "./LicitacaoEsclarecimentoTabela.vue?vue&type=script&lang=js"
import style0 from "./LicitacaoEsclarecimentoTabela.vue?vue&type=style&index=0&id=9b0466fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b0466fa",
  null
  
)

export default component.exports